import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AuthReverseGuard } from './guards/auth-reverse.guard';
import { ExternalTokenGuard } from './guards/external-token.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'forwarder',
    loadComponent: () => import('./public/pages/forwarder/forwarder.page').then( m => m.ForwarderPage)
  },
  {
    path: 'login',
    loadComponent: () => import('./public/pages/login/login.page').then( m => m.LoginPage),
    canActivate: [AuthReverseGuard]
  },
  {
    path: 'home',
    loadComponent: () => import('./admin/pages/dashboard/dashboard.page').then( m => m.DashboardPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'notifications',
    loadComponent: () => import('./admin/pages/notifications/notifications.page').then( m => m.NotificationsPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'user-roles',
    loadComponent: () => import('./admin/pages/user-roles/user-roles.page').then( m => m.UserRolesPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'available-data',
    loadComponent: () => import('./admin/pages/available-data/available-data.page').then( m => m.AvailableDataPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'field-list',
    loadComponent: () => import('./admin/pages/field-list/field-list.page').then( m => m.FieldListPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'advisories',
    loadComponent: () => import('./admin/pages/manage-recommendations/manage-recommendations.page').then( m => m.ManageRecommendationsPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'upload-model-data',
    loadComponent: () => import('./admin/pages/upload-model-data/upload-model-data.page').then( m => m.UploadModelDataPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'map',
    loadComponent: () => import('./admin/pages/map-layout/map-layout.page').then( m => m.MapLayoutPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'map-v2',
    loadComponent: () => import('./pages/map/map.page').then( m => m.MapPage),
    canActivate:[AuthGuard]
  },
  {
    path: 'executor',
    loadComponent: () => import('./pages/external-executor/external-executor.page').then( m => m.ExternalExecutorPage),
    canActivate:[ExternalTokenGuard]
  }
];
